import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

// Don't remove this component. The extra wrapper prevents strange rendering
// issues for the child component. Something to do with the child rendering only
// on the client.
const StickyNotice = ({ children }) => <Layout>{children}</Layout>

StickyNotice.propTypes = { children: PropTypes.node.isRequired }

export default StickyNotice
